<template>
<div class="chapter">
<div class="inner_page">
<h3 class="sigil_not_in_toc" id="pgepubid00003">Table of Contents.</h3>
<p><br/></p>
<h4 class="sigil_not_in_toc" id="pgepubid00004"><a class="c3 pginternal" href="#/Text/main_0004#CHAPTER_I" id="TOC_1">CHAPTER I.</a><br/>
  Mrs. Hardy’s Resolution.</h4>
<h4 class="sigil_not_in_toc" id="pgepubid00005"><a class="c3 pginternal" href="#/Text/main_0004#CHAPTER_II" id="TOC_2">CHAPTER II.</a><br/>
  The Start.</h4>
<h4 class="sigil_not_in_toc" id="pgepubid00006"><a class="c3 pginternal" href="#/Text/main1.htm#CHAPTER_III" id="TOC_3">CHAPTER III.</a><br/>
  A New Life.</h4>
<h4 class="sigil_not_in_toc" id="pgepubid00007"><a class="c3 pginternal" href="#/Text/main1.htm#CHAPTER_IV" id="TOC_4">CHAPTER IV.</a><br/>
  The Pampas.</h4>
<h4 class="sigil_not_in_toc" id="pgepubid00008"><a class="c3 pginternal" href="#/Text/main1.htm#CHAPTER_V" id="TOC_5">CHAPTER V.</a><br/>
  The Settler’s Home.</h4>
<h4 class="sigil_not_in_toc" id="pgepubid00009"><a class="c3 pginternal" href="#/Text/main2.htm#CHAPTER_VI" id="TOC_6">CHAPTER VI.</a><br/>
  A Tale of the Mexican War.</h4>
<h4 class="sigil_not_in_toc" id="pgepubid00010"><a class="c3 pginternal" href="#/Text/main2.htm#CHAPTER_VII" id="TOC_7">CHAPTER VII.</a><br/>
  Seth Continues His Narrative of the Mexican Adventure.</h4>
<h4 class="sigil_not_in_toc" id="pgepubid00011"><a class="c3 pginternal" href="#/Text/main3.htm#CHAPTER_VIII" id="TOC_8">CHAPTER VIII.</a><br/>
  Farm Work and Amusements.</h4>
<h4 class="sigil_not_in_toc" id="pgepubid00012"><a class="c3 pginternal" href="#/Text/main3.htm#CHAPTER_IX" id="TOC_9">CHAPTER IX.</a><br/>
  Neighbourly Visits and Advice.</h4>
<h4 class="sigil_not_in_toc" id="pgepubid00013"><a class="c3 pginternal" href="#/Text/main4.htm#CHAPTER_X" id="TOC_10">CHAPTER X.</a><br/>
  The Lost Cattle.</h4>
<h4 class="sigil_not_in_toc" id="pgepubid00014"><a class="c3 pginternal" href="#/Text/main5.htm#CHAPTER_XI" id="TOC_11">CHAPTER XI.</a><br/>
  Quiet Times.</h4>
<h4 class="sigil_not_in_toc" id="pgepubid00015"><a class="c3 pginternal" href="#/Text/main5.htm#CHAPTER_XII" id="TOC_12">CHAPTER XII.</a><br/>
  A Steady Hand.</h4>
<h4 class="sigil_not_in_toc" id="pgepubid00016"><a class="c3 pginternal" href="#/Text/main6.htm#CHAPTER_XIII" id="TOC_13">CHAPTER XIII.</a><br/>
  The Indian Attack.</h4>
<h4 class="sigil_not_in_toc" id="pgepubid00017"><a class="c3 pginternal" href="#/Text/main6.htm#CHAPTER_XIV" id="TOC_14">CHAPTER XIV.</a><br/>
  Terrible News.</h4>
<h4 class="sigil_not_in_toc" id="pgepubid00018"><a class="c3 pginternal" href="#/Text/main7.htm#CHAPTER_XV" id="TOC_15">CHAPTER XV.</a><br/>
  The Pampas on Fire.</h4>
<h4 class="sigil_not_in_toc" id="pgepubid00019"><a class="c3 pginternal" href="#/Text/main7.htm#CHAPTER_XVI" id="TOC_16">CHAPTER XVI.</a><br/>
  At the Stake.</h4>
<h4 class="sigil_not_in_toc" id="pgepubid00020"><a class="c3 pginternal" href="#/Text/main8.htm#CHAPTER_XVII" id="TOC_17">CHAPTER XVII.</a><br/>
  Rescued.</h4>
<h4 class="sigil_not_in_toc" id="pgepubid00021"><a class="c3 pginternal" href="#/Text/main9.htm#CHAPTER_XVIII" id="TOC_18">CHAPTER XVIII.</a><br/>
  And Last.</h4>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// main_0002.vue?5f707e32